module.exports = __webpack_public_path__ + "static/img/loadingS.24c5039.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/common/loadingS.gif
// module id = DcPv
// module chunks = 0 1 47